import './App.css';
import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Index from './components/Index';
import Footer from './components/Footer';
import About from './components/About';
import ScrollToTop from './components/ScrollToTop';
import HashLoader from 'react-spinners/HashLoader';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 4000);
  }, []);
  return (
    <React.Fragment>
      {loading ? (
        <div className="loader">
          <HashLoader color="#FF073A" loading={loading} size={50} />
        </div>
      ) : (
        <Router basename="/portfolio">
          <div>
            <Navbar />
            <ScrollToTop />
            <Switch>
              <Route exact path="/" component={Index} />
              <Route exact path="/about" component={About} />
            </Switch>
            <Footer />
          </div>
        </Router>
      )}
    </React.Fragment>
  );
}

export default App;
